import * as moment from 'moment-timezone';
import { LOCAL_TZ } from '../../globals';
import { convert, METERS, NAUTICAL_MILES } from '../../util/units';
import { LatLon } from '../../util/geodesy/latlon';
import { getIntercardinalDirection } from '../../util/geodesy/helpers';
import { Taf } from '../models/taf.model';
import { formatTimeRange, LOCAL_TIME_FMT } from '../../util/datetime-utils';
var TafComponent = /** @class */ (function () {
    function TafComponent() {
        this.distance = null;
        this.direction = null;
        /**
         * Whether to display the TAF in translated mode
         */
        this.translated = true;
    }
    Object.defineProperty(TafComponent.prototype, "raw", {
        get: function () {
            return !this.translated;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TafComponent.prototype, "referencePoint", {
        /**
         * Reference lat/lon. If provided, the distance and bearing from the reference point will be shown in the header
         * (e.g., "25 nm NW").
         */
        set: function (point) {
            this._referencePoint = point;
            this.distance = null;
            this.direction = null;
            if (point) {
                var result = point.vincentyInverse(this.taf.location);
                if (result && !isNaN(result.distance)) {
                    this.distance = convert(result.distance, METERS, NAUTICAL_MILES);
                    this.direction = getIntercardinalDirection(result.initialBearing);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TafComponent.prototype, "issueTimeLocal", {
        get: function () {
            return moment(this.taf.issueTime).tz(LOCAL_TZ).format(LOCAL_TIME_FMT);
        },
        enumerable: true,
        configurable: true
    });
    TafComponent.prototype.formatForecastRange = function (forecast) {
        return formatTimeRange(forecast.validFrom, forecast.validTo);
    };
    TafComponent.prototype.formatChangeIndicator = function (forecast) {
        if (!forecast.changeIndicator) {
            return '';
        }
        if (forecast.changeIndicator === 'PROB' && forecast.probability) {
            return forecast.changeIndicator + forecast.probability;
        }
        return forecast.changeIndicator || '';
    };
    return TafComponent;
}());
export { TafComponent };
